import { render, staticRenderFns } from "./JLpromotionTable.vue?vue&type=template&id=58627d1a&scoped=true"
import script from "./JLpromotionTable.vue?vue&type=script&lang=js"
export * from "./JLpromotionTable.vue?vue&type=script&lang=js"
import style0 from "./JLpromotionTable.vue?vue&type=style&index=0&id=58627d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58627d1a",
  null
  
)

export default component.exports